const Customer = require('@thd-olt-global/thd-customer');
const cookieListForAPI = [
  {
    key: 'tt_search',
    cookie: 'x-ttsearch'
  },
  {
    key: 'search_test',
    cookie: 'search_test'
  },
  {
    key: 'drop_search',
    cookie: 'drop_search'
  },
  {
    key: 'typeahead_test',
    cookie: 'typeahead_test'
  },
  {
    key: 'tnt_sponsored_search',
    cookie: 'tnt_sponsored_search'
  },
  {
    key: 'useFFAService',
    cookie: 'useFFAService'
  },
  {
    key: 'llc-env',
    cookie: 'llc-env'
  },
  {
    key: 'x-user-id',
    cookie: 'thda.u'
  },
];

function isDebugMode(queryParams) {
  if (queryParams) return queryParams['debug'] === 'true';
  return typeof window !== 'undefined' && window.location.search.indexOf('debug') !== -1;
}

const getBrowseCookieValue = (name) => {
  if (typeof document === 'undefined') return null;

  const result = (document.cookie || '').match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  if (result && result[2]) {
    return result[2];
  }
};

function getCookiesForDownstreamAPIs__server(req) {
  const cookies = req.cookies;
  if (!cookies) return {};
  const cookieObj = {};

  cookieListForAPI.forEach(item => {
    let cookie = cookies[item.cookie];
    if (cookie) {
      cookieObj[item.key] = cookie || ''
    }
  });

  return JSON.stringify(cookieObj);
}

function getCookiesForDownstreamAPIs__client() {
  if (!window.cookieUtils) return '';
  const cookieObj = {};

  cookieListForAPI.forEach(item => {
    let cookie = window.cookieUtils.readBrowserCookie(item.cookie);
    if (cookie) {
      cookieObj[item.key] = cookie || ''
    }
  });

  return JSON.stringify(cookieObj);
}

function getThdExperimentLayoutCookie(req) {
    const cookieName = 'x-tt-thd-layout';
    if(req && req.cookies && req.cookies[cookieName]){
        return req.cookies[cookieName];
    } else {
        return getBrowseCookieValue(cookieName);
    }
}

function getStorefrontCookie(req){
  const cookieName = 'THD_STOREFRONT';
  if(req && req.cookies && req.cookies[cookieName]){
    return req.cookies[cookieName];
  } else {
    return getBrowseCookieValue(cookieName);
  }
}
function decodeStorefrontCookie(req) {
  const encodedStorefrontCookie = getStorefrontCookie(req);
  if(encodedStorefrontCookie != null) {
    try {
      return JSON.parse(Buffer.from(encodedStorefrontCookie.split('.')[1], 'base64').toString());
    } catch(e) {
    }
  }
  return null;
}

function getHeadersByCustomerType(req) {
  const cust = req
      ? new Customer.ConfigurableCustomer(req.headers.cookie)
      : Customer.default;

  const storefrontCookie = decodeStorefrontCookie(req);

  if(storefrontCookie != null) {
    return {
      'x-svoc-id': storefrontCookie.SVOCID || '',
    }
  }

  if (!cust || !cust.customerType) return {};

  if (cust.customerType.toLowerCase() === 'b2b'){
    return {
      'x-svoc-id': cust.svocID || '',
      'x-user-id': cust.userID || '',
      'x-customer-type': cust.customerType || '',
      'x-customer-role': cust.role || '',
      'x-thd-customer-token': cust.jwt || '',
      'x-segment-id': cust.segment || ''
    }
  }

  if (cust.customerType.toLowerCase() === 'b2c'){
    return { 'x-thd-customer-token': cust.jwt || '' };
  }

  return {};
}

function getAuthHeadersForAPI(req) {
  const customerToken = getCustomerTokenHeaders(req);
  const ssoToken = getSSOTokenHeader(req);
  const authHeader = getAuthorizationHeader(req);
  return {
    ...customerToken,
    ...ssoToken,
    ...authHeader
  }
}

function getAuthorizationHeader(req) {
  if(req) {
    return {
      'x-thd-authorization' : req.get('Authorization')
    }
  }
}

function getCustomerTokenHeaders(req) {
  const cust = req && req.headers
      ? new Customer.ConfigurableCustomer(req.headers.cookie)
      : Customer.default;

  const storefrontCookie = decodeStorefrontCookie(req);

  if(storefrontCookie != null)  {
    return {
      'x-svoc-id': storefrontCookie.SVOCID || '',
    };
  }


  if (!cust || !cust.customerType) return {};

  return {
    'x-thd-customer-token': cust.jwt || '',
  }
}

function getSSOTokenHeader(req) {
  const ssoHeaders = {};
  const ssoBrowserCookie = getBrowseCookieValue('THDSSO');

  if (req && req.cookies && req.cookies.THDSSO) {
    ssoHeaders['x-thd-sso'] = req.cookies.THDSSO;
  } else if (ssoBrowserCookie) {
    ssoHeaders['x-thd-sso'] = ssoBrowserCookie;
  }

  return ssoHeaders;
}

function getCookiesForDownstreamAPIs(req) {
  if (req) return getCookiesForDownstreamAPIs__server(req);
  return getCookiesForDownstreamAPIs__client();
}

function getBetaCookie({ isServer, req }) {
  const cookieName = 'HD_DC';
  if (isServer && req && req.cookies) {
    const cookies = req.cookies || {};
    return cookies[cookieName] || '';
  }

  if (typeof window !== 'undefined') {
    return getBrowseCookieValue(cookieName) || '';
  }

  return '';
}

function getCustomerInfo(req) {
  let customer;
  if (!req && typeof window !== 'undefined' && typeof document !== 'undefined' && document.cookie) {
    customer = new Customer.ConfigurableCustomer(document.cookie);
  } else {
    customer = new Customer.ConfigurableCustomer(req.headers.cookie);
  }

  const { customerType, role, userID, svocID, jwt, membershipInformation } = customer;

  const storefrontCookie = decodeStorefrontCookie(req);

  return {
    type: customerType && customerType.toLowerCase() || 'b2c',
    role: role && role.toUpperCase(),
    userId: userID && userID.toUpperCase(),
    svocId: svocID && svocID.toUpperCase(),
    jwt,
    membershipInformation,
    ...(storefrontCookie ? { thd_storefront: storefrontCookie } : {})
  };
}


module.exports = {
  getB2BHeaders: getHeadersByCustomerType,
  getCookiesForDownstreamAPIs,
  getAuthHeadersForAPI,
  getBrowseCookieValue,
  decodeStorefrontCookie,
  getThdExperimentLayoutCookie,
  getCustomerInfo,
  getCommonHeadersForAPI({ isServer, req, queryParams }) {
    return {
      'x-hd-dc': getBetaCookie({ isServer, req }),
      'X-Api-Cookies': getCookiesForDownstreamAPIs(isServer ? req : null) || '',
      'x-debug': isDebugMode(isServer ? queryParams : null),
      ...getHeadersByCustomerType(isServer ? req : null)
    };
  }
};
